<template>
  <div
    class="login_wrapper_wrapper"
    :style="{
      backgroundImage: `url(${login_bg})`,
      'background-repeat': 'no-repeat',
      'background-size': '100% 100%',
    }"
  >
    <div class="login_wrapper">
      <div
        class="login-left"
        :style="{
          'background-repeat': 'no-repeat',
          'background-size': '100% 100%',
        }"
      >
        <!-- background: `url(${bgImg})`, -->
        <div class="logo">
          <!-- <div class="logo_img">
          <div>大连高新区</div>
          </div>-->
          <div class="login_title_blod">大连高新区</div>
          <div class="login_title">河马艺术</div>
        </div>
      </div>
      <!-- 登录 -->
      <div class="login" v-if="loginOrRegister == 1">
        <el-form :model="loginForm" ref="loginForm" :rules="loginRules">
          <el-form-item style="text-align: center;margin-bottom:50px">
            <!-- <div class="back_home" @click="backHome">
            <span class="el-icon-arrow-left"></span>
            <span>返回首页</span>
            </div>-->
            <div class="title">登录</div>
            <!-- <div class="title2">
            WELCOME TO SHENYANG TECHNOLOGY PROPERTY RIGHTS EXCHANGE CENTER
            </div>-->
          </el-form-item>
          <el-form-item prop="usci" v-if="loginType == 1" class="login_item">
            <el-input
              clearable
              v-model="loginForm.usci"
              placeholder="请输入企业统一社会信用代码"
            >
              <img
                slot="prefix"
                style="width:31px;height:31px"
                src="@/assets/login/login_icon.png"
                alt
              />
              <!-- <span slot="prefix">
              <el-button
                type="text"
                style="margin-left: 10px; border: none; color: #c0c4cc"
              >
                <el-dropdown
                  trigger="click"
                  style="cursor: pointer; color: #3b75dd"
                  @command="handleCommand"
                >
                  <span class="el-dropdown-link">
                    <span>{{ loginType == 1 ? "账号" : "手机号" }}</span>
                    <i
                      style="margin: 0"
                      class="el-icon-arrow-down el-icon--right"
                    ></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="username">账号</el-dropdown-item>
                    <el-dropdown-item command="telephone"
                      >手机号</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </el-button>
              <span style="margin-left:10px;">账号</span>
              </span>-->
            </el-input>
          </el-form-item>
          <el-form-item
            prop="password"
            v-if="loginType == 1"
            class="login_item"
          >
            <el-input
              clearable
              show-password
              type="password"
              v-model="loginForm.password"
              placeholder="请输入密码"
              style="position: relative"
            >
              <img
                slot="prefix"
                style="width:31px;height:31px"
                src="@/assets/login/password_icon.png"
                alt
              />
              <!-- <span slot="prefix">
              <el-button type="text">密码</el-button>
              </span>-->
            </el-input>
            <!-- <el-button
            class="Account"
            style="color: #bebebe"
            type="text"
            @click="loginOrRegister = 3"
            >忘记密码?</el-button
            >-->
          </el-form-item>
          <el-form-item
            prop="code"
            v-if="captchaEnabled && loginType == 1"
            class="login_item safe_item"
          >
            <el-input
              clearable
              v-model="loginForm.code"
              placeholder="请输入验证码"
              style="position: relative"
            >
              <img
                slot="prefix"
                style="width:31px;height:31px"
                src="@/assets/login/safe_icon.png"
                alt
              />
            </el-input>
            <div class="login-code">
              <img :src="codeUrl" @click="getCode" class="login-code-img" />
            </div>
          </el-form-item>
          <div class="forget_item">
            <!-- <el-checkbox @change="handleclickchange" v-model="userchecked"
              >记住密码</el-checkbox
            >-->
            <el-button
              style="color: #E51537"
              type="text"
              @click="toRouterPush('/forget')"
              >忘记密码?</el-button
            >
          </div>
          <el-form-item prop="telephone" v-if="loginType == 2">
            <el-input
              clearable
              v-model="loginForm.telephone"
              placeholder="请输入手机号"
            >
              <span slot="prefix">
                <el-button
                  type="text"
                  style="margin-left: 10px; border: none; color: #c0c4cc"
                >
                  <el-dropdown
                    trigger="click"
                    style="cursor: pointer; color: #3b75dd"
                    @command="handleCommand"
                  >
                    <span class="el-dropdown-link">
                      <span>{{ loginType == 1 ? "账号" : "手机号" }}</span>
                      <i
                        style="margin: 0"
                        class="el-icon-arrow-down el-icon--right"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="username"
                        >账号</el-dropdown-item
                      >
                      <el-dropdown-item command="telephone"
                        >手机号</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-button>
                <!-- <span style="margin-left:10px;">账号</span> -->
              </span>
            </el-input>
          </el-form-item>
          <el-form-item prop="captcha" v-if="loginType == 2">
            <el-input v-model="loginForm.captcha" placeholder="请输入验证码">
              <span slot="prefix">
                <el-button type="text">验证码</el-button>
              </span>
              <span slot="append">
                <el-button
                  type="text"
                  v-if="wait2 == 0"
                  @click="getloginCaptcha()"
                  >获取验证码</el-button
                >
                <el-button type="text" v-if="wait2 != 0" @click.stop
                  >{{ wait2 }}秒</el-button
                >
              </span>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="loginBtn" @click="loginSubmit()">登录</el-button>
            <el-button class="toLogin" @click="toRouterPush('/register')"
              >注册</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- 注册 -->
      <div class="register" v-if="loginOrRegister == 2">
        <el-form
          ref="registerForm"
          :rules="registerRules"
          :model="registerForm"
        >
          <el-form-item>
            <!-- <div class="back_home" @click="backHome">
            <span class="el-icon-arrow-left"></span>
            <span>返回首页</span>
            </div>-->
            <h2 class="title">账号注册</h2>
            <!-- <div class="title2">
            WELCOME TO SHENYANG TECHNOLOGY PROPERTY RIGHTS EXCHANGE CENTER
            </div>-->
          </el-form-item>
          <el-form-item prop="telephone" label="手机号">
            <el-input
              clearable
              v-model="registerForm.telephone"
              placeholder="请输入手机号"
            >
              <!-- <span slot="prefix">
              <el-button type="text">
                <span>账号</span>
                <span style="color: #ff6c5f; margin-left: 6px">*</span>
              </el-button>
              </span>-->
            </el-input>
          </el-form-item>
          <!-- <el-form-item prop="telephone" >
          <el-input
            clearable
            v-model="registerForm.telephone"
            placeholder="请输入手机号"
          >
            <span slot="prefix">
              <el-button type="text">
                <span>手机号</span>
              </el-button>
            </span>
          </el-input>
          </el-form-item>-->
          <el-form-item prop="captcha" label="手机验证码">
            <el-input
              v-model="registerForm.captcha"
              placeholder="请输入手机验证码"
              style="position: relative"
            >
              <!-- <span slot="prefix">
              <el-button type="text">验证码</el-button>
              </span>-->
            </el-input>
            <el-button
              class="Account"
              type="text"
              v-if="wait == 0"
              @click="getRegistercaptcha()"
              >获取验证码</el-button
            >
            <el-button class="Account" type="text" v-if="wait != 0" @click.stop
              >{{ wait }}秒</el-button
            >
            <div v-if="wait != 0" class="sms_sending">
              短信已经发送您手机，十分钟内有效
            </div>
          </el-form-item>
          <el-form-item prop="password" label="密码">
            <el-input
              clearable
              show-password
              type="password"
              v-model="registerForm.password"
              placeholder="请输入密码"
            >
              <!-- <span slot="prefix">
              <el-button type="text">
                <span>密码</span>
                <span style="color: #ff6c5f; margin-left: 6px">*</span>
              </el-button>
              </span>-->
            </el-input>
            <el-input
              clearable
              show-password
              type="password"
              v-model="registerForm.againpassword"
              placeholder="请再次输入密码"
              style="margin-top: 20px"
            >
              <!-- <span slot="prefix">
              <el-button type="text">
                <span>密码</span>
                <span style="color: #ff6c5f; margin-left: 6px">*</span>
              </el-button>
              </span>-->
            </el-input>
          </el-form-item>
          <div style="text-align: left">
            <el-checkbox v-model="checked"></el-checkbox>
            <div
              class="can_click platform_protocol"
              @click="toProtocol('PALTFORM_PROTOCOL')"
            >
              我已经阅读并同意
              <a class="terms_of_service" href>服务条款、隐私政策</a>
            </div>
          </div>
          <el-form-item>
            <el-button
              style="margin-top: 14px"
              class="loginBtn"
              @click="registerSubmit('registerForm')"
              >注 册</el-button
            >
            <div class="toLogin" @click="toLogin()">已注册，去登录 ></div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 忘记密码 -->
      <div class="register" v-if="loginOrRegister == 3">
        <el-form ref="forgetForm" :rules="registerRules" :model="forgetForm">
          <el-form-item>
            <!-- <div class="back_home" @click="backHome">
            <span class="el-icon-arrow-left"></span>
            <span>返回首页</span>
            </div>-->
            <h2 class="title">忘记密码</h2>
            <!--<div class="title3">
            WELCOME TO SHENYANG TECHNOLOGY PROPERTY RIGHTS EXCHANGE CENTER
            </div>-->
          </el-form-item>
          <!-- <div class="backLogin" @click="loginOrRegister = 1">
          <span class="el-icon-back"></span>
          返回登录
          </div>-->
          <el-form-item prop="telephone" label="手机号">
            <el-input
              clearable
              v-model="forgetForm.telephone"
              placeholder="请输入手机号"
            >
              <!-- <span slot="prefix">
              <el-button type="text">
                <span>账号</span>
              </el-button>
              </span>-->
            </el-input>
          </el-form-item>
          <!-- <el-form-item prop="telephone">
          <el-input
            clearable
            v-model="forgetForm.telephone"
            placeholder="请输入手机号"
          >
            <span slot="prefix">
              <el-button type="text">
                <span>手机号</span>
              </el-button>
            </span>
          </el-input>
          </el-form-item>-->
          <el-form-item prop="captcha" label="手机验证码">
            <el-input
              v-model="forgetForm.captcha"
              placeholder="请输入手机验证码"
            >
              <!-- <span slot="prefix">
              <el-button type="text">验证码</el-button>
              </span>-->
            </el-input>
            <el-button
              class="Account"
              type="text"
              v-if="wait == 0"
              @click="getForgetcaptcha()"
              >获取验证码</el-button
            >
            <el-button type="text" v-if="wait != 0" @click.stop
              >{{ wait }}秒</el-button
            >
            <div v-if="wait != 0" class="sms_sending">
              短信已经发送您手机，十分钟内有效
            </div>
          </el-form-item>
          <el-form-item prop="password" label="重设密码">
            <el-input
              clearable
              show-password
              type="password"
              v-model="forgetForm.password"
              placeholder="请输入密码"
            >
              <!-- <span slot="prefix">
              <el-button type="text">
                <span>新密码</span>
              </el-button>
              </span>-->
            </el-input>
            <el-input
              clearable
              show-password
              type="password"
              v-model="forgetForm.againpassword"
              placeholder="请再次输入密码"
              style="margin-top: 20px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="loginBtn" @click="forgetSubmit('forgetForm')"
              >确 认</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- 认证类型弹窗 -->
      <el-dialog
        title
        :visible.sync="dialogVisible"
        width="471px"
        :show-close="false"
        top="15vh"
      >
        <!-- <div slot="title">
        <img style="width:100%" src="@/assets/login/authBg@2x.png" alt="" />
        </div>-->
        <div class="dialogContent">
          <div class="tips">是否继续进行认证？</div>
          <div
            class="typeBox"
            v-for="(item, index) in authTypeData"
            :key="index"
          >
            <!-- <el-radio-group style="width:100%" v-model="authType">
            <div>
              <el-radio :label="1">高校</el-radio>
              <el-radio :label="2">企业</el-radio>
              <el-radio :label="3">自然人</el-radio>
            </div>
            </el-radio-group>-->
            <div
              class="active"
              :style="{
                backgroundImage: `url(${item.bgImg})`,
              }"
              v-if="authType == item.id"
            >
              <div class="authTitleBox">
                <div class="authTypeTitle">{{ item.title }}</div>
                <div class="authTypeDesc">{{ item.desc }}</div>
              </div>
            </div>
            <div v-else class="authItem" @click="authType = item.id">
              <div class="authTypeTitle2">{{ item.title }}</div>
              <div class="authTypeDesc2">{{ item.desc }}</div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <div class="footerBox">
            <el-button plain @click="later()">稍后认证</el-button>
            <el-button type="primary" @click="toAuth()">继续</el-button>
          </div>
        </span>
      </el-dialog>
      <!-- 认证 -->
      <!-- <AuthPage :authVisible.sync="authVisible"
      :authType="authType" :telephone="registerForm.telephone" v-if="authVisible" :authForm="authForm"></AuthPage>-->
      <!-- 注册成功 -->
      <el-dialog
        title
        :visible.sync="dialogVisibleaccess"
        width="342px"
        show-close
        top="40vh"
      >
        <div class="registered_success">
          <img src="@/assets/login/Frame@2x.png" alt />
          <div>注册成功</div>
        </div>
        <div class="Direct_login">恭喜您，注册成功！您可以直接登录。</div>
        <el-button class="loginBtn1" @click="Directlogin()">直接登录</el-button>
      </el-dialog>
      <!-- 修改密码 -->
      <el-dialog
        title
        :visible.sync="dialogVisibleamend"
        width="342px"
        show-close
        top="40vh"
      >
        <div class="registered_success">
          <img src="@/assets/login/Frame@2x.png" alt />
          <div>修改成功</div>
        </div>
        <div class="Direct_login">恭喜您，已成功修改为新密码。</div>
        <el-button class="loginBtn1" @click="Directlogineamend()"
          >直接登录</el-button
        >
      </el-dialog>
    </div>
  </div>
</template>
<script>
// login, logout, getInfo,
import {
  captcha,
  loginIn,
  register,
  forget,
  getAuthInfo,
  getCodeImg,
} from "@/api/login";
// import AuthPage from "@/components/Auth/index";
// import { setSessionStorage } from "@/utils/util";
import { setStore, setToken } from "@/utils/auth";
import Utils from "@/utils/util";
import secret from "@/utils/secret";
import Cookies from "js-cookie";
export default {
  name: "login",
  // components:{ AuthPage },
  data() {
    return {
      codeUrl: "",
      login_bg: require("@/assets/login/login_bg.png"),
      userchecked: false,
      loginRememb: null,
      dialogVisibleaccess: false,
      dialogVisibleamend: false,
      loginOrRegister: 1,
      loginType: 1,
      wait2: 0,
      maxWaiting2: 60,
      loginForm: {
        type: 1,
        usci: "",
        password: "",
        uuid: "",
        code: "",
      },
      loginRules: {
        usci: [{ required: true, trigger: "blur", message: "请输入您的账号" }],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
        ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }],
      },
      wait: 0,
      maxWaiting: 60,
      registerForm: {
        username: "",
        telephone: "",
        captcha: "",
        password: "",
      },
      registerRules: {
        // username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        // telephone: [
        //   { required: true, message: "请输入手机号", trigger: "blur" }
        // ],
        // captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        // password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      forgetForm: {
        username: "",
        telephone: "",
        captcha: "",
        password: "",
      },
      checked: false,
      dialogVisible: false,
      verifyStatus: null,
      authType: 1,
      authVisible: false,
      authForm: {},
      // c菜单
      sysMenuVoList: [],
      authTypeData: [
        {
          id: 1,
          title: "高校",
          desc:
            "高校认证宣传话语说明高校认证宣传话语说明高校认证宣传话语说明高校认证宣传话语",
        },
        {
          id: 2,
          title: "企业",
          desc: "企业认证宣传话语说明企业认证宣传话语说明",
        },
        {
          id: 3,
          title: "个人",
          desc: "个人认证宣传话语说明自然人认证宣传话语说明自然传话话…",
        },
      ],
      setoken: "",
      decodeusername: "",
      decodepassword: "",
      // 验证码开关
      captchaEnabled: true,
    };
  },
  watch: {},
  created() {
    this.getCode();
    this.loginOrRegister = this.$route.query.flag || 1;
    Utils.$on("loginOrRegister", (msg) => {
      this.loginOrRegister = msg;
    });
    //取出本地存储的记住密码状态
    let loginRememb = window.localStorage.getItem("loginRememb");
    // console.log(loginRememb,'勾选状态');
    if (loginRememb == "true") {
      let username = Cookies.get("username");
      let password = Cookies.get("password");
      // console.log(username, password, "勾选状态", loginRememb);
      this.loginForm.telephone = secret.Decrypt(username);
      this.loginForm.password = secret.Decrypt(password);
      // this.userchecked = true;
    }
  },
  mounted() {},
  methods: {
    getCode() {
      getCodeImg().then((res) => {
        this.captchaEnabled =
          res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.loginForm.uuid = res.uuid;
        }
      });
    },
    //返回首页
    backHome() {
      this.toRightPath("/");
    },
    // 获取注册验证码
    getRegistercaptcha() {
      let that = this;
      if (
        !/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
          that.registerForm.telephone
        )
      ) {
        that.$message({
          message: "请输入正确手机号",
          type: "error",
        });
      } else {
        that.wait = that.maxWaiting;
        let timer = setInterval(() => {
          that.wait--;
          if (that.wait == 0) {
            clearInterval(timer);
            that.wait = 0;
          }
        }, 1000);
        captcha({ type: 1, telephone: that.registerForm.telephone })
          .then(function(response) {
            if (response.code == 1) {
              that.$message({
                message: "验证码已发送",
                type: "success",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    // 注册
    registerSubmit(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.registerForm.password === that.registerForm.againpassword) {
            if (that.checked == false) {
              that.$message({
                message: "请阅读服务条款、隐私政策",
                type: "error",
              });
            } else {
              let postData = that.$common.copyObj(that.registerForm);
              if (
                !that.$common.isEmpty(postData.telephone) &&
                that.$common.isEmpty(postData.captcha)
              ) {
                that.$message({
                  message: "请输入验证码",
                  type: "error",
                });
              } else {
                register(postData)
                  .then(function(response) {
                    if (response.code == 1) {
                      // that.$message({
                      //   message: "注册成功",
                      //   type: "success"
                      // });
                      // setToken(response.data.token);
                      // that.dialogVisible = true;
                      that.dialogVisibleaccess = true;
                      that.setoken = response.data.token;
                    }
                  })
                  .catch(function(error) {
                    console.log(error);
                  });
              }
            }
          } else {
            that.$message.error("两次密码不一致");
          }
        } else {
          that.$message.error("请检查填写信息");
          return false;
        }
      });
    },
    later() {
      this.dialogVisible = false;
      this.toRightPath("/");
    },
    async toAuth() {
      // this.authVisible = true;
      this.$router.replace({
        path: "/Auth",
        query: {
          authType: this.authType,
          telephone: this.registerForm.telephone,
        },
      });
      this.dialogVisible = false;
    },
    toLogin() {
      this.$refs.registerForm.clearValidate();
      this.loginOrRegister = 1;
      // this.$refs.loginForm.resetFields();
    },
    toRegister() {
      this.$refs.loginForm.clearValidate();
      this.loginOrRegister = 2;
      // this.$refs.registerForm.resetFields();
    },
    handleCommand(command) {
      if (command == "username") {
        this.loginType = 1;
        this.loginForm.type = 1;
      } else {
        this.loginType = 2;
        this.loginForm.type = 2;
      }
    },
    // 获取登录验证码
    getloginCaptcha() {
      let that = this;
      if (
        !/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
          that.loginForm.telephone
        )
      ) {
        that.$message({
          message: "请输入正确手机号",
          type: "error",
        });
      } else {
        that.wait2 = that.maxWaiting;
        let timer = setInterval(() => {
          that.wait2--;
          if (that.wait2 == 0) {
            clearInterval(timer);
            that.wait2 = 0;
          }
        }, 1000);
        captcha({ type: 1, telephone: that.loginForm.telephone })
          .then(function(response) {
            if (response.code == 1) {
              that.$message({
                message: "验证码已发送",
                type: "success",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    // 登录
    async loginSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.login()
            .then()
            .catch((error) => {
              console.log(error);
              if (/企业审核中或审核未通过/.test(error)) {
                console.log("去注册页");
                this.toRouterPush("/register", { usci: this.loginForm.usci });
              }
              if (this.captchaEnabled) {
                this.getCode();
              }
            });
        }
      });
    },
    async login() {
      let postData = this.$common.copyObj(this.loginForm);
      const res = await loginIn(postData);
      setToken(res.token);
      setStore("userInfo", JSON.stringify(res.data));
      // 储存勾选状态
      window.localStorage.setItem("loginRememb", this.loginRememb);
      //判断是否勾选记住密码
      if (this.loginRememb) {
        let cipherText = secret.Encrypt(postData.telephone);
        let cipherTextpa = secret.Encrypt(postData.password);
        Cookies.set("username", cipherText, { expires: 30 });
        Cookies.set("password", cipherTextpa, { expires: 30 });
      } else {
        //如果此时没有勾选记住密码,就把cookies里面的参数移除
        Cookies.remove("username");
        Cookies.remove("password");
      }
      this.$message.success("登录成功");
      this.toRightPath("/");
      // -----------------------------------------------
      // 改变header登录状态
      this.$EventBus.$emit("childByValue", true);
      this.registerForm.telephone = res.data.telephone;
      const authInfo = await getAuthInfo();
      // if (authInfo.data.authType === 0){
      //   this.dialogVisible = true;
      // }
      console.log(authInfo);
      if (!this.$common.isEmpty(authInfo.data)) {
        this.verifyStatus = authInfo.data.verifyStatus;
        console.log(this.verifyStatus);
      }
      // if (
      //   this.$common.isEmpty(authInfo.data) ||
      //   this.$common.isEmpty(this.verifyStatus)
      // )
      // if (authInfo.data.authType === 0) {
      //   this.dialogVisible = true;
      // } else if (this.verifyStatus != 2) {
      //   this.authForm = authInfo.data;
      //   this.authType = authInfo.data.authType;
      //   this.$router.replace({
      //     path: "/Auth",
      //     query: {
      //       authType: authInfo.data.authType,
      //       telephone: this.registerForm.telephone,
      //       verifyStatus: this.verifyStatus,
      //     },
      //     // authForm:this.authForm
      //   });
      // } else {
      //   this.$message.success("登录成功");
      //   this.toRightPath("/");
      // }
      // if(res.data.isBusinessAuth==2){
      //   this.$message.success("登录成功");
      //   this.$router.replace({ path: "/index" });
      // }else if(res.data.isBusinessAuth==0 || this.$common.isEmpty(res.data.isBusinessAuth)){
      //   this.dialogVisible = true;
      // }else if(res.data.isBusinessAuth==1){
      //   this.$message({
      //     message: '认证申请正在审核中，请耐心等待',
      //     type: 'warning'
      //   });
      // }else{
      //  const authInfo =  await getAuthInfo();
      //  console.log(authInfo);
      //   this.authForm = authInfo.data;
      //   this.authType = authInfo.data.authType;
      //   this.$router.replace({
      //     path:"/Auth",
      //     query:{
      //       authType:authInfo.data.authType,
      //       telephone:this.registerForm.telephone,
      //       authForm:this.authForm
      //     }
      //   })
      //   // this.authVisible = true;
      // }
    },
    // 获取忘记密码验证码
    getForgetCaptcha() {
      let that = this;
      if (
        !/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
          that.forgetForm.telephone
        )
      ) {
        that.$message({
          message: "请输入正确手机号",
          type: "error",
        });
      } else {
        that.wait2 = that.maxWaiting;
        let timer = setInterval(() => {
          that.wait2--;
          if (that.wait2 == 0) {
            clearInterval(timer);
            that.wait2 = 0;
          }
        }, 1000);
        captcha({ type: 2, telephone: that.forgetForm.telephone })
          .then(function(response) {
            if (response.code == 1) {
              that.$message({
                message: "验证码已发送",
                type: "success",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    // 忘记密码
    forgetSubmit(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.forgetForm.password === that.forgetForm.againpassword) {
            let postData = that.$common.copyObj(that.forgetForm);
            if (
              !that.$common.isEmpty(postData.telephone) &&
              that.$common.isEmpty(postData.captcha)
            ) {
              that.$message({
                message: "请输入验证码",
                type: "error",
              });
            } else {
              forget(postData)
                .then(function(response) {
                  if (response.code == 1) {
                    // that.$message({
                    //   message: "操作成功",
                    //   type: "success",
                    // });
                    // that.loginOrRegister = 1;
                    that.dialogVisibleamend = true;
                  }
                })
                .catch(function(error) {
                  console.log(error);
                });
            }
          } else {
            that.$message.error("两次密码不一致");
          }
        } else {
          that.$message.error("请检查填写信息");
          return false;
        }
      });
    },
    handleclickchange(e) {
      console.log(e);
      this.loginRememb = e;
    },
    Directlogin() {
      setToken(this.setoken);
      this.toRightPath("/");
    },
    Directlogineamend() {
      this.loginOrRegister = 1;
      this.dialogVisibleamend = false;
    },
  },
};
</script>

<style lang="less">
.el-input .el-input__clear {
  background-color: #fff;
  height: calc(100% - 3px);
  margin-top: 2px;
}
.login_wrapper_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
}
.login_wrapper {
  width: 1332px;
  height: 720px;
  display: flex;
  align-items: center;
  justify-content: center;
  .Direct_login {
    font-size: 14px;
    font-weight: 400;
    color: #969799;
    text-align: center;
    margin-top: 14px;
  }
  .registered_success {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 22px;
      height: 22px;
    }
    div {
      font-size: 20px;
      font-weight: 400;
      color: #000000;
      margin-left: 4px;
    }
  }
  .sms_sending {
    font-size: 14px;
    font-weight: 400;
    color: #c8c9cc;
    text-align: center;
    height: 0vh;
  }
  .logo {
    display: flex;
    flex-direction: column;
    gap: 14px;
    position: absolute;
    // top: 251px;
    // left: 59px;
    .logo_img {
      display: flex;
      align-items: center;
      margin-bottom: 31px;
      img {
        width: 42px;
        height: 42px;
        border-radius: 50%;
      }
      div {
        font-size: 21px;
        font-weight: 400;
        color: #ffffff;
        margin-left: 9px;
      }
    }
    .login_title {
      font-size: 54px;
      font-weight: 500;
      color: #ffffff;
      line-height: 63px;
      font-family: Source Han Sans CN, Source Han Sans CN;
    }
    .login_title_blod {
      color: #ffffff;
      font-size: 64px;
      font-weight: bold;
      line-height: 75px;
      font-family: Source Han Sans CN, Source Han Sans CN;
    }
  }
  .login-left {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #df181880;
    width: 666px;
    height: 100%;
    text-align: center;
    position: relative;
    img {
      width: 66.6%;
      height: 100vh;
    }
    // .titleBox {
    //   margin-top: 42vh;
    //   text-align: center;
    //   word-wrap: break-all;
    //   .webTitle {
    //     span {
    //       font-size: 50px;
    //       font-family: PingFang SC;
    //       font-weight: bold;
    //       line-height: 70px;
    //       color: #ffffff;
    //     }
    //   }
    // }
  }
  .login {
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - 666px);
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    .back_home {
      cursor: pointer;
      margin: 20vh 0 0 0;
      /*font-size: 12px;*/
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #0c2879;
      line-height: 17px;
      :last-child {
        margin-left: 6px;
      }
    }
    .title {
      display: inline-block;
      font-size: 32px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      color: #df1818;
      line-height: 38px;
      text-align: center;
      text-align: center;
      border-bottom: 3px solid #df1818;
    }
    .title2 {
      font-size: 14px;
      font-family: D-DIN, D;
      font-weight: normal;
      color: #999999;
      margin: 0 0 79px 0;
      line-height: 27px;
    }

    .el-form-item__content {
      width: 100%;
      // width: 27.7vw;
    }

    .el-form {
      width: 406px;
      text-align: left;
      .error {
        display: block;
        text-align: center;
        color: red;
      }
    }
    .Account {
      position: absolute;
      top: 48px;
      right: 13px;
    }
  }
  .register {
    width: calc(100% - 666px);
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    .back_home {
      cursor: pointer;
      margin: 10vh 0 0 0;
      /*font-size: 12px;*/
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #0c2879;
      line-height: 17px;
      :last-child {
        margin-left: 6px;
      }
    }
    .title {
      font-size: 26px;
      text-align: center;
      color: #505458;
      margin: 2vh 0 30px 0;
    }
    .title2 {
      font-size: 12px;
      text-align: left;
      color: #505458;
      margin: 0 0 70px 0;
    }
    .title3 {
      font-size: 12px;
      text-align: left;
      color: #505458;
      margin: 0 0 50px 0;
    }
    .backLogin {
      text-align: left;
      margin-bottom: 20px;
      color: #0c2879;
      cursor: pointer;
    }

    .el-form-item__content {
      width: 100%;
    }

    .el-form {
      width: 406px;
      text-align: left;
      .error {
        display: block;
        text-align: center;
        color: red;
      }
    }
    .Account {
      position: absolute;
      top: 48px;
      right: 13px;
    }
  }
  .loginBtn {
    width: 193px;
    height: 56px;
    background: linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
    opacity: 1;
    border-radius: 5px;
    font-size: 26px;
    font-weight: 400;
    line-height: 0px;
    color: #ffffff;
  }
  .loginBtn1 {
    width: 141px;
    height: 35px;
    background: linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    margin-top: 30px;
    border-radius: 10px 10px 10px 10px;
    margin-left: 50%;
    transform: translateX(-50%);
  }
  // .loginBtn:hover {
  //   width: 30vw;
  //   height: 40px;
  //   background: #3b75dd;
  //   opacity: 1;
  //   // border-radius: 35px;
  //   font-size: 16px;
  //   font-family: PingFang SC;
  //   font-weight: 400;
  //   line-height: 0px;
  //   color: #ffffff;
  //   margin-top: 67px;
  //   border: none;
  // }
  .toLogin {
    margin-left: 20px;
    width: 193px;
    height: 56px;
    background: #ffffff;
    opacity: 1;
    border-radius: 5px;
    border: 1px solid linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
    font-size: 26px;
    font-weight: 400;
    line-height: 0px;
    color: linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
    text-align: center;
    cursor: pointer;
  }
  .dialogContent {
    // text-align: center;
    // padding: 20px 24px;
    .tips {
      font-size: 20px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: #020202;
      line-height: 26px;
    }
    .typeBox {
      width: 100%;
      margin-top: 20px;
      font-size: 14px;
      .active {
        width: 100%;
        height: 205px;
        background-size: 100% 100%;
        position: relative;
        cursor: pointer;
        .authTitleBox {
          width: calc(100% - 46px);
          height: auto;
          background: linear-gradient(
            180deg,
            rgba(53, 53, 53, 0) 0%,
            rgba(24, 24, 24, 0.66) 100%
          );
          position: absolute;
          bottom: 0;
          padding: 13px 23px;
          border-radius: 10px;
          .authTypeTitle {
            font-size: 18px;
            font-family: PingFang-SC-Bold, PingFang-SC;
            font-weight: bold;
            color: #ffffff;
            line-height: 26px;
          }
          .authTypeDesc {
            width: 100%;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 22px;
            margin-top: 5px;
            opacity: 0.7;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box; //作为弹性伸缩盒子模型显示。
            -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
            -webkit-line-clamp: 2; //显示的行
          }
        }
      }
      .authItem {
        border-radius: 10px;
        border: 1px solid #e2edff;
        padding: 13px 23px;
        cursor: pointer;
        .authTypeTitle2 {
          font-size: 18px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: #020202;
          line-height: 26px;
        }
        .authTypeDesc2 {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #020202;
          line-height: 22px;
          margin-top: 5px;
          opacity: 0.7;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box; //作为弹性伸缩盒子模型显示。
          -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
          -webkit-line-clamp: 2; //显示的行
        }
      }
    }
  }
  .el-input__inner {
    display: flex;
    align-items: center;
    // padding-left: 80px !important;
  }
  .el-input__prefix {
    background: rgba(255, 255, 255, 0);
    // padding-top: 10px;
  }
  .el-input-group__append {
    background: rgba(255, 255, 255, 0);
    border-radius: 0 10px 10px 0;
    .el-button--text {
      padding-right: 20px;
      padding-left: 20px;
      color: linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
    }
  }
  .el-dropdown {
    // padding-left: 10px;
  }
  .el-dialog__header {
    padding: 0 !important;
  }
  .el-dialog {
    border-radius: 10px !important;
  }
  .el-dialog__footer {
    text-align: center;
    .el-button {
      width: 210px;
      height: 46px;
      border-radius: 8px;
      border: 1px solid linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
      padding: 0;
      line-height: 35px;
      background-color: transparent;
      color: linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
    }
    .el-button--primary {
      border: none;
      height: 46px;
      background-color: linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
      color: #ffffff;
    }
    .el-button--primary:hover {
      border: none;
      height: 46px;
      background-color: linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
      color: #ffffff;
    }
  }
}

.forget_item {
  padding-right: 8px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 70px;
}
</style>
<style lang="less" scoped>
.login_wrapper {
  .el-input__prefix {
    .el-button {
      background-color: transparent;
      margin-left: 10px;
      border: none;
      color: #c0c4cc;
      cursor: text;
    }
  }
  .el-input-group__append .el-button--text {
    color: linear-gradient( 90deg, #68A4FF 0%, #166DF0 100%) ;
  }
  ::v-deep .el-form-item__label {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
  }
  ::v-deep .el-input__inner {
    height: 56px;
    border-radius: 10px;
  }
  ::v-deep .el-input__inner::placeholder {
    font-size: 16px;
    font-weight: 400;
    color: #cccccc;
  }
  ::v-deep input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px rgba(255, 255, 255, 0) inset !important;
    /* -webkit-text-fill-color: #fff; */
    -webkit-transition-delay: 99999s;
    -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
  }
  ::v-deep .el-checkbox__inner {
    width: 22px;
    height: 22px;
  }
  ::v-deep .el-checkbox__inner::after {
    left: 8px;
    top: 5px;
  }
  .forgeye {
    ::v-deep .el-input__suffix-inner {
      margin-right: 80px;
    }
  }
  .login_item {
    ::v-deep {
      .el-input--prefix .el-input__inner {
        padding-left: 67px;
      }
      .el-input__prefix {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 18px;
      }
      .login-code {
        position: absolute;
        top: 0;
        right: 0;
        width: 129px;
        height: 100%;
        border-radius: 5px;
        img {
          cursor: pointer;
          vertical-align: middle;
        }
      }
      .login-code-img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .safe_item {
    ::v-deep {
      margin-bottom: 0;
      .el-input {
        width: 267px;
      }
    }
  }
}
</style>
